import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import App from "./App";
import "./index.css";

// Força um hash novo de arquivo no build - cache externo (provavelmente
// LiteSpeed/Varnish) ficou preso servindo um main.js antigo/corrompido na
// URL anterior, e um comentário sozinho não basta porque o Terser remove
// comentários (bundle final ficava byte-a-byte idêntico, mesmo hash).
window.__buildTag = "2026-10-20a";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

if ("serviceWorker" in navigator) {

  if (!localStorage.getItem("sw_cache_reset_v1")) {
    caches.keys().then((keys) =>
      Promise.all(keys.map((k) => caches.delete(k)))
    ).then(() => {
      localStorage.setItem("sw_cache_reset_v1", "1");
    });
  }

  // Se esta página já carregou sob controle de um service worker ATIVO (visita
  // anterior), o PRÓXIMO controllerchange é uma ATUALIZAÇÃO de verdade (SW novo
  // substituindo o antigo) - aí sim vale recarregar pra pegar a versão nova.
  // Numa instalação NOVA (PWA recém-instalado), controller começa null e o
  // PRIMEIRO controllerchange é só a ativação inicial, não uma atualização -
  // recarregar aqui não tem nada a "atualizar" e só derruba qualquer coisa em
  // andamento na página (ex: o registro de push logo após o login, que roda em
  // paralelo bem nesse momento - era exatamente isso que fazia o dispositivo
  // nunca salvar em Web.Dispositivos na primeira instalação, 2026-09-28).
  // Listener fica sempre ligado (senão uma atualização de verdade que aconteça
  // mais tarde, com o app já aberto há um tempo, nunca recarregaria) - só o
  // PRIMEIRO disparo, quando começou sem controlador nenhum, é ignorado.
  let temControlador = !!navigator.serviceWorker.controller;

  navigator.serviceWorker
    .register("/service-worker.js", { updateViaCache: "none" })
    .then((registration) => {
      registration.update();
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") registration.update();
      });
    });

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!temControlador) {
      temControlador = true;
      return;
    }
    window.location.reload();
  });

}
